import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

[].slice.call(document.styleSheets).forEach(function (sheet) {
  [].slice.call(sheet.cssRules || []).forEach(function (rule) {
    if (rule.type === CSSRule.FONT_FACE_RULE) rule.style.fontDisplay = "swap";
  });
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
